import { useMemo } from "react";

import "./CIICalculationPage.scss";

import BreadCrumb from "../../common/breadCrumb/BreadCrumb";
import CIICalculator from "../../components/CIICalculator/CIICalculator";

const CIICalculationPage = () => {
	const breadCrumb = useMemo(
		() => [
			{
				label: "Annual Emission Verification",
				url: "",
				navId: "annual_emission_verification_navid",
			},
			{
				label: "CII Calculator",
				url: "",
				navId: "ciicalculator_navid",
			},
		],
		[]
	);

	return (
		<div className="col-md-12">
			<div className="bred-crumb-cont">
				<BreadCrumb items={breadCrumb} />
				<div class="emmision-reporter-heading">CII Calculator</div>
			</div>

			<CIICalculator />
		</div>
	);
};

export default CIICalculationPage;
